import React, { useEffect, useRef, useState } from 'react';
import JsBarcode from 'jsbarcode';
import styles from './BoletoBarCodeDisplay.module.css';

interface BoletoBarCodeDisplayProps {
  barCode: string;
}

const normalizeBarCodeDigits = (barCode: string): string => barCode.replace(/\D/g, '');

const BoletoBarCodeDisplay: React.FC<BoletoBarCodeDisplayProps> = ({ barCode }) => {
  const svgRef = useRef<SVGSVGElement>(null);
  const [renderError, setRenderError] = useState(false);
  const digits = normalizeBarCodeDigits(barCode);

  useEffect(() => {
    if (!svgRef.current || digits.length < 44) {
      setRenderError(true);
      return;
    }

    try {
      JsBarcode(svgRef.current, digits, {
        format: 'ITF',
        displayValue: false,
        height: 64,
        width: 1.4,
        margin: 8,
      });
      setRenderError(false);
    } catch {
      setRenderError(true);
    }
  }, [digits]);

  if (renderError || digits.length < 44) {
    return null;
  }

  return (
    <div className={styles.wrapper} aria-hidden>
      <svg ref={svgRef} className={styles.barcode} role="img" aria-label="Código de barras do boleto" />
    </div>
  );
};

export default BoletoBarCodeDisplay;
